import { render, staticRenderFns } from "./ErrorMessageBox.vue?vue&type=template&id=2d17e638&scoped=true"
import script from "./ErrorMessageBox.vue?vue&type=script&lang=ts"
export * from "./ErrorMessageBox.vue?vue&type=script&lang=ts"
import style0 from "./ErrorMessageBox.vue?vue&type=style&index=0&id=2d17e638&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d17e638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d17e638')) {
      api.createRecord('2d17e638', component.options)
    } else {
      api.reload('2d17e638', component.options)
    }
    module.hot.accept("./ErrorMessageBox.vue?vue&type=template&id=2d17e638&scoped=true", function () {
      api.rerender('2d17e638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ErrorMessageBox.vue"
export default component.exports